import { useQuery } from 'react-query'
import { api } from '../../../../../services/api'
import { useUser } from '../../../../../hooks/useUser'

export function useProdutos() {
  const { codigo_usuario } = useUser() // Obtendo o código do usuário

  const fetchProdutos = async () => {
    const response = await api.get('/site/v2/tercerizado/listagem-produtos', {
      params: {
        codigo_usuario, // Adicionando o código do usuário aos parâmetros
      },
    })
    return response.data
  }

  return useQuery('@produtos-terceirizados', fetchProdutos, {
    staleTime: 1000 * 60 * 10, // 10 minutos
    refetchOnWindowFocus: false,
    retry: 2,
  })
}
